import React, { Component, PropTypes } from 'react'
import { connect } from 'react-redux'
import CSSModules from 'react-css-modules'
import config from 'config'
import * as searchActions from 'redux/modules/search'
import {
  Works,
  Link,
  LinkIcon,
  AykCtaPanel,
  // RecentBlogPosts,
  GetStartedInput,
  Banner401k,
  FamilyGrid,
  BenchmarkGrid,
  TargetDateGrid,
  SrOnly,
  AutocompleteSearch,
} from '../../components'
import ReactPlayer from 'react-player'

const Styles = require('./Home.css')

@connect(
  state => ({
    signupsubmit: state.signupsubmit.result
  }),
  searchActions)
@CSSModules(Styles, {allowMultiple:true})
export default class Home extends Component {
  static propTypes = {
    signupsubmit: PropTypes.bool
  }

  constructor() {
    super()

    this.state = {
      openModal: true,
    }
  }

  componentWillMount() {
    if (typeof window !== 'undefined') {
      window.scrollTo(0,0)
    }
  }

  componentDidMount() {
    const signupsubmit = this.props.signupsubmit ? this.props.signupsubmit : false
    this.props.signupsubmitChange(signupsubmit)
  }

  clickCloseModal = () =>{
    this.props.signupsubmitChange(true)
  }

  renderSignupToaster = () => {
    return (
      <div styleName='signup-toaster-wrap'>
        <div styleName='signup-toaster-container'>
          <div styleName='signup-toaster-inner'>
            <div styleName='signup-toaster'>
              <div styleName='signup-toaster-tagline'>
                Get updates on the climate risk of your funds
              </div>
              <div styleName='signup-toaster-inner-wrap'>
                <div styleName='signup-toaster-form-wrap'>
                  <form styleName='signup-toaster-form'
                    acceptCharset="UTF-8"
                    method="post"
                    action="https://go.pardot.com/l/344561/2017-05-15/4zx"
                    target="signup_confirmation">
                    <input styleName='signup-toaster-input'
                      name="344561_1307pi_344561_1307"
                      type="email"
                      placeholder="Get email updates"
                      size="25"
                      required
                    />
                    <div styleName='signup-toaster-button-group'>
                      <input styleName='signup-toaster-submit'
                        type="submit"
                        value="Stay in touch"
                      />
                      <div style={{
                        position: 'absolute',
                        left: '-9999px',
                        top: '-9999px',
                      }}>
                        <label htmlFor="pardot_extra_field">Comments</label>
                        <input type="text" id="pardot_extra_field" name="pardot_extra_field" />
                      </div>
                      <div
                        styleName='signup-toaster-no-thanks'
                        onClick={ this.clickCloseModal }
                        title='Close'>
                        <div styleName='signup-toaster-more'>
                          Close <i styleName='signup-toaster-close' className='fa fa-times-circle'/>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderBanner = () => {
    const aysLogo = require('../../../static/images/AsYouSow_Logo_color.svg')
    return (
      <div styleName='banner-wrapper'>
        <div styleName='banner-darken'>
          <div styleName='banner-container'>
            <div styleName='banner-container-inner'>
              <div styleName='banner-title'>
                Don't want your retirement savings invested in fossil fuels?
              </div>

              <div styleName='banner-btn-wrap'>
                <div styleName='banner-tagline'>
                  See mutual funds and ETFs that avoid fossil fuel investments
                </div>
                <Link
                  to={config.routes.clean}
                  bigbutton
                  title='Top-rated funds'
                >
                  <div>
                    Top-rated funds<LinkIcon />
                  </div>
                </Link>
              </div>

              <div styleName='banner-tagline'>
                Search funds from your 401(k) or IRA for fossil fuel holdings
              </div>
              <AutocompleteSearch />

              <div styleName='banner-btn-wrap'>
                <div styleName='logo-tagline'>A project of</div>
                <Link to={config.links.ays} title='As You Sow'>
                  <img
                    styleName={'logo-ays'}
                    src={aysLogo}
                    alt='As You Sow'
                  />
                  <SrOnly>As You Sow</SrOnly>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  renderLede = () => {
    const icon = require( '../../../static/images/icn-ays.png' )
    // const link = config.domain
    // const message = config.shareMessage
    return (
      <div styleName='x-lede'>
        <div styleName='x-lede-inner'>
          <div styleName='media-col'>
            <div styleName='media-icon-title-wrap'>
              <img
                styleName='media-icon'
                alt='From As You Sow'
                src={icon}
              />
              <div styleName='media-title-wrap'>
                <div styleName='media-title'>Introducing: Fossil Free Funds</div>
                <div styleName='media-subtitle'>From As You Sow</div>
              </div>
            </div>
            <div styleName='media-react-player-wrap'>
              <ReactPlayer
                url='https://vimeo.com/222906557'
                volume={0.5}
              />
            </div>
          </div>
          <div styleName='lede-col'>
            <div styleName='x-lede-title'>
              Fossil free investing made easy
            </div>
            <div styleName='x-lede-subtitle'>
              <strong>Fossil fuel investments carry real financial risks.</strong> Over the past years, a growing divestment movement of institutional and individual investors representing trillions in assets under management have responded to this climate risk by divesting all or some of their fossil fuel investments.
            </div>
            <div styleName='x-lede-subtitle'>
              <strong>Fossil Free Funds</strong> analyzes the fossil fuel exposure and carbon footprint of thousands of U.S. mutual funds and ETFs. We make it easy to know what you own, so you can align your investments with your values.
            </div>
            <div styleName='x-lede-btn'>
              <Link
                to={config.routes.about}
                title={'About | ' + config.app.title}
                roundbutton
              >
                <LinkIcon nospace faclass='fa-info-circle'/>&nbsp;&nbsp;Learn more<LinkIcon />
              </Link>
            </div>
          </div>
          { /* <SocialButtons
            message={message}
            link={link}
          /> */ }
        </div>
      </div>
    )
  }

  renderPressHighlights = () => {
    const nytLogo = require( '../../../static/images/nyt-logo.png' )
    const lnks = [
      [
        config.links.guardianHome,
        'The Guardian - The carbon bubble: why investors can no longer ' +
          'ignore climate risks',
        require( '../../../static/images/guardian-300.jpg' )
      ],
      [
        config.links.bloombergHome,
        'Bloomberg BNA - GE, Microsoft Urged to Offer Fossil-Fuel-Free ' +
          '401(k)s',
        require( '../../../static/images/bloomberg-300.jpg' )
      ],
      [
        config.links.fastcompanyHome,
        'FastCompany - How To Convince Your Employer To Divest Your 401(k) ' +
          'From Fossil Fuels',
        require( '../../../static/images/fast-company-300.jpg' )
      ],
      [
        config.links.thinkprogressHome,
        'ThinkProgress - There’s Now A Way To Find Out How Much Of Your ' +
          'Retirement Is Invested In Fossil Fuels',
        require( '../../../static/images/think-progress-300.jpg' )
      ],
    ]

    return (
      <div styleName='x-press-banner'>
        <div styleName='x-press'>
          <div styleName='x-press-inner'>
            <blockquote styleName='blckqt'>
              <p>
                If you care about climate change, your money can help shrink your carbon footprint... Now there is a tool, the website Fossil Free Funds, that helps pinpoint funds and E.T.F.s focused on companies with smaller carbon footprints.
              </p>
              <cite styleName='blckqtct'>
                <Link
                  to={config.links.nytHome}
                  title={
                    'New York Times - Funds That Can Put Your Investments' +
                    ' on a Low-Carbon Diet'
                  }
                >
                  <div styleName='blckqtct-flx'>
                    <div>
                      Funds That Can Put Your Investments on a Low-Carbon Diet
                    </div>
                    <img
                      styleName='nyt-logo'
                      src={nytLogo}
                      alt='New York Times - Funds That Can Put Your Investments on a Low-Carbon Diet'
                    />
                  </div>
                </Link>
              </cite>
            </blockquote>

            <div styleName='lnk-logo-title'>
              Read more about us in:
            </div>
            <div styleName='lnk-logos'>
              {
                lnks.map((e, i) => {
                  // e = [url, title/alt, img src]
                  return (
                    <Link
                      to={e[0]}
                      title={e[1]}
                      key={'lnk-logo-' + i}
                    >
                      <img
                        styleName='lnk-logo'
                        src={e[2]}
                        alt={e[1]}
                      />
                    </Link>
                  )
                })
              }
            </div>

          </div>
        </div>
      </div>
    )
  }

  renderTrailingContent = () => {
    const icons = [
      [require( '../../../static/images/icn-c2-active-black.svg' ), 'Top carbon reserve owners'],
      [require( '../../../static/images/icn-co-active-black.svg' ), 'Coal industry'],
      [require( '../../../static/images/icn-og-active-black.svg' ), 'Oil/gas industry'],
      [require( '../../../static/images/icn-f5-active-black.svg' ), 'Top coal-fired utilities'],
      [require( '../../../static/images/icn-ut-active-black.svg' ), 'Fossil-fired utilities']
    ]
    return (
      <div styleName='x-401k'>
        <div styleName='x-401k-inner'>
          <div styleName='x-container-title'>
            Tracking trillions in fossil fuel investments
          </div>
          <div styleName='x-401k-info-photo'>
            <div styleName='x-401k-info'>
              <div styleName='x-401k-trailing-icons'>
                {
                  icons.map((el, idx) => {
                    return (
                      <img
                        key={'fossil-icon-'+idx}
                        src={el[0]}
                        alt={el[1]}
                        styleName='x-401k-trailing-icon'
                      />
                    )
                  })
                }
              </div>
              <p styleName='x-401k-top'><strong>Fossil Free Funds</strong> is a search platform that looks at the climate impact of popular mutual funds and shows you if your money is being invested in fossil fuel companies, or companies with high carbon footprints.</p>
              <p><strong>Investing in coal companies, oil/gas producers, and coal-fired utilities isn’t just a moral question.</strong> Fossil fuel investments carry real financial risks. When emissions are constrained, fossil fuel companies will have their carbon assets stranded. Over the past years, a growing divestment movement of institutional and individual investors representing more than $6tn in assets under management have responded to this risk by divesting all or some of their fossil fuel investments.</p>
              <p><strong>Fossil Free Funds</strong> empowers you to know exactly what you own, to see if your savings are invested in dirty energy sources, and to find investment options that support a cleaner, greener future.</p>
              <p><strong>Search for mutual funds and see if they’re invested in fossil fuel companies.</strong> If they are, you can use our database to find comparable options that meet your specific needs.</p>
            </div>
          </div>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div styleName="main">

        { /*
          (this.props.signupsubmit) ?
            null :
            this.renderSignupToaster()
        */ }

        { this.renderBanner() }

        <AykCtaPanel />

        { this.renderLede() }

        <Works/>

        <br/>
        <br/>

        { /*
        <Banner401k />
        */ }

        <br/>
        <br/>

        { /*
        <BenchmarkGrid />
        */ }

        <br/>
        <br/>

        { /*
        <TargetDateGrid />
        */ }

        { /*
        this.renderPressHighlights()
        */ }

        { /*
        <FamilyGrid topN={12}/>
        */ }

        { /*
        <RecentBlogPosts />
        */ }

        { /*
        this.renderTrailingContent()
        */ }

        { /*
        <GetStartedInput />
        */ }

      </div>
    )
  }
}

